var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "deliveries-svg",
    d: "M23.5 12c.778 0 1.42.596 1.493 1.356L25 13.5v.5h2.5a2.503 2.503 0 0 1 2.495 2.336L30 16.5V18h1.5a2.503 2.503 0 0 1 2.495 2.336L34 20.5v6a.5.5 0 0 1-.41.492L33.5 27h-2a.5.5 0 1 1 0-1H33v-1h-3.516c.322.421.516.943.516 1.5 0 1.355-1.145 2.5-2.5 2.5-1.185 0-2.208-.875-2.447-2H20.5a.5.5 0 1 1 0-1h4.552c.078-.367.24-.709.465-1.001h-7.033c.322.422.516.944.516 1.501 0 1.355-1.145 2.5-2.5 2.5-1.184 0-2.208-.875-2.447-2H10a.5.5 0 0 1-.5-.5v-6a.5.5 0 1 1 1 0V24H24V13.5a.5.5 0 0 0-.5-.5h-14a.5.5 0 1 1 0-1h14zm-7 13c-.813 0-1.5.687-1.5 1.5s.687 1.5 1.5 1.5 1.5-.687 1.5-1.5-.687-1.5-1.5-1.5zm11 0c-.813 0-1.5.687-1.5 1.5s.687 1.5 1.5 1.5 1.5-.687 1.5-1.5-.687-1.5-1.5-1.5zm-12.984 0H10.5v1h3.552c.078-.367.24-.708.464-1zM26.5 19a.5.5 0 1 1 0-1H29v-1.5c0-.827-.673-1.5-1.5-1.5H25v9h8v-3.5c0-.827-.673-1.5-1.5-1.5h-5zm-10-1a.5.5 0 1 1 0 1h-7a.5.5 0 1 1 0-1h7zm-1-2a.5.5 0 1 1 0 1h-7a.5.5 0 1 1 0-1h7zm-2-2a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1h6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b-deliveries-svg",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deliveries-svg"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#deliveries-svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#b-deliveries-svg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveries);
export default __webpack_public_path__ + "static/media/deliveries.d0af668f925fa850f9eb223a0c1f8472.svg";
export { ForwardRef as ReactComponent };